import { render, staticRenderFns } from "./TeamSwitcher.vue?vue&type=template&id=49b3de5a&scoped=true"
import script from "./TeamSwitcher.vue?vue&type=script&lang=js"
export * from "./TeamSwitcher.vue?vue&type=script&lang=js"
import style0 from "./TeamSwitcher.vue?vue&type=style&index=0&id=49b3de5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b3de5a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VIcon,VProgressCircular})
